module.exports = __webpack_public_path__ + "static/media/avatar.cc4364f3.jpg";